export default __webpack_public_path__ + "static/media/SD-gallery-08.6ca65e76.png";